export const playerConfig = {
  maxWithdrawCount: "Max Withdraw Count",
  maxWithdrawBasedMinutes: "Max Withdraw Based Minutes",
  save: "Save",
  withdrawCountLimit: "*จำนวนครั้งที่ถอนได้",
  doNotChange: "*ห้ามเปลี่ยน",
};
